(function (algolia) {
  'use strict';

  var renderRangeSlider = (renderOptions, isFirstRender) => {
    var { start, range, refine, widgetParams } = renderOptions;

    if (isFirstRender) {
      widgetParams.container.innerHTML = algolia.getTemplate('instant_search_range_slider');

      var gteInputEl = widgetParams.container.querySelector('[data-gte-input]');
      var lteInputEl = widgetParams.container.querySelector('[data-lte-input]');

      gteInputEl.addEventListener('change', () => {
        refine([gteInputEl.value, lteInputEl.value]);
      });

      lteInputEl.addEventListener('change', () => {
        refine([gteInputEl.value, lteInputEl.value]);
      });

      return;
    }

    var gteInputEl = widgetParams.container.querySelector('[data-gte-input]');
    var lteInputEl = widgetParams.container.querySelector('[data-lte-input]');

    var gteEl = widgetParams.container.querySelector('[data-gte]');
    var lteEl = widgetParams.container.querySelector('[data-lte]');

    gteInputEl.min = 0;
    gteInputEl.max = range.max;
    gteInputEl.value = Number.isFinite(start[0]) ? start[0] : '0';

    lteInputEl.min = range.min;
    lteInputEl.max = range.max;
    lteInputEl.value = Number.isFinite(start[1]) ? start[1] : range.max;

    if (gteInputEl.valueAsNumber > gteInputEl.min || lteInputEl.valueAsNumber < lteInputEl.max) {
      widgetParams.container.classList.add('ais-range-slider-is-changed');
    } else {
      widgetParams.container.classList.remove('ais-range-slider-is-changed');
    }

    gteEl.innerHTML = algolia.formatMoney(gteInputEl.value);
    lteEl.innerHTML = algolia.formatMoney(lteInputEl.value);
  };

  var rangeSlider = algolia.externals.connectors.connectRange(renderRangeSlider);

  var menu = algolia.externals.widgets.menu;

  var refinementList = algolia.externals.widgets.refinementList;

  var TYPES_TO_WIDGET = {
    slider: {
      name: 'rangeSlider',
      widget: rangeSlider,
    },
    menu: { name: 'menu', params: { limit: 10 }, widget: menu },
    conjunctive: {
      name: 'refinementList',
      params: { operator: 'and', limit: 10 },
      widget: refinementList,
    },
    disjunctive: {
      name: 'refinementList',
      params: { operator: 'or', limit: 100 },
      widget: refinementList,
    },
  };

  var sortByRefined = function sortByRefined(sortFunction) {
    return function (a, b) {
      if (a.refined !== b.refined) {
        if (a.refined) {
          return -1;
        }
        if (b.refined) {
          return 1;
        }
      }
      return sortFunction(a, b);
    };
  };

  /*
   * Sorting functions : Allows to chose in which order you want to display the facets
   * Algolia will always send you back the most relevant values for each facet (the ones
   * with the highest count). These sorting functions won't change which results come back
   * but how they are displayed. To retrieve more results, change the maxValuesPerFacet
   * parameter in your Algolia Dashboard.
   * The default sort function is refined > count > name.
   */
  algolia.facetSortFunctions = {
    price_range: sortByRefined(function sortRanges(a, b) {
      if (a.name.length === b.name.length) {
        return a.name.localeCompare(b.name);
      }
      return a.name.length - b.name.length;
    }),
    'meta.filter.footwear_size': function sortFootwearSize(a, b) {
      return a.name.localeCompare(b.name, undefined, {numeric: true});
    },
    'meta.filter.clothing_size': function sortClothingSize(a, b) {
      var sorted = ['XX-SMALL', 'X-SMALL','SMALL','MEDIUM','LARGE','X-LARGE','XX-LARGE','ONE SIZE'];
      if (a.name === b.name) {
        return 0;
      }

      return sorted.indexOf(a.name) > sorted.indexOf(b.name) ? 1 : -1;
    },
  };

  /*
   * Display functions
   * When the object sent back for a facet item doesn't match how you would want it to look
   * like, use a function to reformat it how you want.
   */
  algolia.facetDisplayFunctions = {
    price_range: function displayRange(value) {
      var values = value.split(':');

      return values
        .map(function (e) {
          return algolia.formatMoney(Number(e) * 100).replace(/\.\d+/, '');
        })
        .join(' - ');
    },
  };

  algolia.facetCssClasses = {
    root: 'ais-facet',
    header: 'ais-facet--header',
    body: 'ais-facet--body',
    item: 'ais-facet--item',
    label: 'ais-facet--label',
    checkbox: 'ais-facet--checkbox',
    active: 'ais-facet--active',
    count: 'ais-facet--count',
  };

  var enabledFacets = algolia.config.facets.filter(function (facet) {
    return facet.enabled || parseInt(facet.enabled, 10);
  });
  algolia.facets = enabledFacets.map(function (facet) {
    return algolia.assign({}, facet, {
      escapedName: encodeURIComponent(facet.name),
    });
  });
  algolia.shownFacets = algolia.facets.filter(function (facet) {
    return facet.type !== 'hidden';
  });
  algolia.hiddenFacets = algolia.config.facets.filter(function (facet) {
    return facet.type === 'hidden';
  });

  var facetToWidget = function (facet) {
    var widget = TYPES_TO_WIDGET[facet.type];
    var params = algolia.assign({}, widget.params);

    params.container = "[class~='ais-facet-" + facet.escapedName + "-container']";
    params.attribute = facet.name;
    params.templates = {};
    params.cssClasses = algolia.facetCssClasses;

    /**
     * Providing a custom "Show more" template to confirm to the custom
     * Hogan delimiter
     */
    params.templates.showMoreText = algolia.getTemplate('instant_search_facet_show_more');

    if (facet.searchable) {
      params.searchable = true;
      params.searchablePlaceholder = 'Search for ' + facet.title;
      params.templates.searchableNoResults = '<div> No matching for ' + facet.title + '</div>';
    }

    params.templates.header = function () {
      return facet.title;
    };

    if (!widget.useDefault) {
      params.templates.item = algolia.getTemplate('instant_search_facet_item');
    }

    if (algolia.facetSortFunctions[facet.name]) {
      params.sortBy = algolia.facetSortFunctions[facet.name];
    } else {
      params.sortBy = ['name:asc'];
    }

    var displayFunction = algolia.facetDisplayFunctions[facet.name];
    params.transformItems = function (items) {
      return items.map(function (item) {
        var transformedItem = algolia.assign({}, item);
        transformedItem.type = {};
        transformedItem.type[facet.type] = true;
        transformedItem.label = displayFunction ? displayFunction(item.value) : item.value;
        transformedItem.id = encodeURIComponent(`facet-${facet.name}-${item.value}`).replace(/[^\w\s]/gi, '');
        return transformedItem;
      });
    };

    return {
      name: widget.name,
      params: params,
      widget: widget.widget,
    };
  };

  // try to fetch facets for current collection or fallback to collections default
  var collection_facets =
    algolia.current_collection_id &&
    algolia.config.collection_facets &&
    algolia.config.collection_facets[algolia.current_collection_id]
      ? algolia.config.collection_facets[algolia.current_collection_id]
      : algolia.config.collection_facets && algolia.config.collection_facets.default;

  if (collection_facets) {
    var enabledCollectionFacets = collection_facets.filter(function (facet) {
      return facet.enabled || parseInt(facet.enabled, 10);
    });

    algolia.collectionFacets = enabledCollectionFacets.map(function (facet) {
      return algolia.assign({}, facet, {
        escapedName: encodeURIComponent(facet.name),
      });
    });
    algolia.collectionShownFacets = algolia.collectionFacets.filter(function (facet) {
      return facet.type !== 'hidden';
    });
    algolia.collectionHiddenFacets = collection_facets.filter(function (facet) {
      return facet.type === 'hidden';
    });
    algolia.collectionFacetsWidgets = algolia.collectionShownFacets.map(facetToWidget);
  }
  algolia.facetsWidgets = algolia.shownFacets.map(facetToWidget);
})(window.algoliaShopify);
